var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_786_10160",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 16,
    height: 17
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 12.2109C20 7.79266 16.4183 4.21094 12 4.21094C7.58172 4.21094 4 7.79266 4 12.2109C4 16.6292 7.58172 20.2109 12 20.2109C16.4183 20.2109 20 16.6292 20 12.2109Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_786_10160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 12.2109C20 7.79266 16.4183 4.21094 12 4.21094C7.58172 4.21094 4 7.79266 4 12.2109C4 16.6292 7.58172 20.2109 12 20.2109C16.4183 20.2109 20 16.6292 20 12.2109Z",
    fill: "#6E51E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 12.2109C20 7.79266 16.4183 4.21094 12 4.21094C7.58172 4.21094 4 7.79266 4 12.2109C4 16.6292 7.58172 20.2109 12 20.2109C16.4183 20.2109 20 16.6292 20 12.2109Z",
    fill: "url(#paint0_linear_786_10160)",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9812 13.8259L15.6612 9.14494L16.3822 9.86494L10.9812 15.2669L7.74023 12.0259L8.46023 11.3059L10.9802 13.8259H10.9812Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_786_10160",
    x1: 12,
    y1: 4.21094,
    x2: 12,
    y2: 20.2109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.a184d37534cba30875ad119363f2fccf.svg";
export { ForwardRef as ReactComponent };